module.exports = __webpack_public_path__ + "static/img/bgday.8147183.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/bgday.png
// module id = nIjW
// module chunks = 1